import { IIconProps } from '~/types';
const VndFlag = (props: IIconProps) => (
  <svg
    width={28}
    height={20}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={28} height={20} rx={2} fill="#fff" />
    <mask
      id="a"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={28}
      height={20}
    >
      <rect width={28} height={20} rx={2} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path fill="#EA403F" d="M0 0h28v20H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14 12.34-3.527 2.514 1.301-4.13-3.48-2.578 4.33-.04L14 4l1.375 4.107 4.331.039-3.48 2.577 1.3 4.131z"
        fill="#FFFE4E"
      />
    </g>
  </svg>
);
export default VndFlag;
